/// <amd-module name="CodeCoverage/CodeCoverageCiChangedTab/ChangedTabDataProviderService" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";

import { mapChangedFilesToFileCoverageTableItem } from "CodeCoverage/CodeCoverageCiChangedTab/Helpers";
import { CoverageChangeSummaryResponse } from "CodeCoverage/Clients/Coverage/Contracts/Coverage";
import { getCoverageClient } from "CodeCoverage/Clients/Coverage/RestClient/Coverage";
import { IFileCoverageTableItem } from "CodeCoverage/ViewCommon/Contracts/Common";

export interface ICoverageChangeResponse {
    fileCoverageChanges: IFileCoverageTableItem[];
    continuationToken?: string;
}

export interface IChangedTabDataProviderService extends IVssService {
    getCoverageChangesDataAsync(project: string, pipelineRunId: number, scope?: string, continuationToken?: string): Promise<ICoverageChangeResponse>;
}

// exported for testing
export class ChangedTabDataProviderService extends VssService implements IChangedTabDataProviderService {
    public getCoverageChangesDataAsync(
        project: string,
        pipelineRunId: number,
        scope?: string,
        continuationToken?: string
    ): Promise<ICoverageChangeResponse> {
        return getCoverageClient(this.pageContext)
            .getChanges(project, pipelineRunId, scope, continuationToken)
            .then((response: CoverageChangeSummaryResponse) => {
                const fileCoverageChanges: IFileCoverageTableItem[] = [];
                const newContinuationToken = response.continuationToken == null ? undefined : response.continuationToken;

                if (response.coverageChangeSummary != null && response.coverageChangeSummary.fileCoverageChanges != null) {
                    mapChangedFilesToFileCoverageTableItem(response.coverageChangeSummary.fileCoverageChanges).forEach(item =>
                        fileCoverageChanges.push(item)
                    );
                }

                return {
                    fileCoverageChanges,
                    continuationToken: newContinuationToken
                };
            });
    }
}

Services.add("IChangedTabDataProviderService", { serviceFactory: ChangedTabDataProviderService });
